<div class="d-flex flex-column justify-content-center align-items-center h-100 w-100">

    <div class="bg-primary-light-color w-100 mb-1 p-2">
        <p class="font-weight-bold mb-0">{{labels.totalDiscountAlertLabel}} {{ selectedTotalDiscount }}%</p>
    </div>

    <div class="row w-100">

        <div class="col-12 col-lg-6">

            <app-discounts-checkbox-selector
                [discounts]="discountsWithoutCode"
                [(selectedDiscountCodes)]="selectedDiscountsWithoutCode"
                (selectedDiscountCodesChange)="onSelectedDiscountsChange()">
            </app-discounts-checkbox-selector>

        </div>

        <div class="col-12 col-lg-6">

            <app-discount-code-input
                [discounts]="discountsWithCode"
                [(selectedDiscountCodes)]="selectedDiscountsWithCode"
                (selectedDiscountCodesChange)="onSelectedDiscountsChange()">
            </app-discount-code-input>

        </div>

    </div>

</div>
